import { useState } from 'react';
import { setConsent } from '@/shared/lib/analytics';
import type { ConsentChoice } from '@/shared/lib/consent';
import { shouldAskConsent } from '@/shared/lib/consent';
import { Banner } from '@/shared/ui/banner';
import { Button } from '@/shared/ui/button';

const TITLE_ID = 'consent-banner-title';

/**
 * The website's analytics cookie question, for visitors in the EEA, the UK and Switzerland who reach the app
 * before answering it on macswarm.com. Both answers weigh the same; the choice covers the website too.
 */
export function ConsentBanner() {
  const [isOpen, setIsOpen] = useState(shouldAskConsent);
  if (!isOpen) return null;

  const choose = (choice: ConsentChoice) => {
    setConsent(choice);
    setIsOpen(false);
  };

  return (
    <section
      aria-labelledby={TITLE_ID}
      className="fixed inset-x-4 bottom-4 z-toast sm:right-auto sm:max-w-xl"
    >
      <Banner
        id={TITLE_ID}
        className="bg-surface shadow-lg"
        title="Analytics cookies?"
        action={
          <div className="flex gap-2">
            <Button onClick={() => choose('denied')}>No thanks</Button>
            <Button onClick={() => choose('granted')}>Allow</Button>
          </div>
        }
      >
        Google Analytics and PostHog show us which pages help. Without cookies we still count
        visits, but cannot tell repeat visits apart. The choice also applies on macswarm.com.
      </Banner>
    </section>
  );
}
